import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { OpenActions } from "../../actions/open.actions";
import { VendorReviewState } from "../../models/open/vendor-review-state";

const initialState: VendorReviewState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(OpenActions.vendorReviews.getSuccess, (state, action) =>
		_.set(
			_.merge(_.cloneDeep(state), { loading: action.loading }),
			["reviews", action.vendorId],
			action.reviews
		)
	),
	on(OpenActions.vendorReviews.getFail, (state, action) => ({
		...state,
		..._.omit(action, "type")
	}))
);

export function vendorReviewReducer(
	state: VendorReviewState | undefined,
	action: Action
): VendorReviewState {
	return reducer(state, action);
}
